// Generated TypeScript interfaces for employment_type

export enum EmploymentType {
  EMPLOYEE = 1,
  CONSULTANT = 2
}

